var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "meta-61",
  "use": "meta-61-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" id=\"meta-61\"><g stroke=\"#4E4E4E\" stroke-width=\"1.3\" fill=\"none\" fill-rule=\"evenodd\"><rect x=\"7.65\" y=\"6.65\" width=\"16.7\" height=\"18.7\" rx=\"4\" /><circle cx=\"16\" cy=\"16\" r=\"1\" /><path d=\"M13 12v7m6-6v7m-6-7h7m-8 6h7\" stroke-linecap=\"round\" /></g></symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol